var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGasIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 477.3 477.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.6 73.65h-177c-5.5 0-10 4.5-10 10v117c0 5.5 4.5 10 10 10h177c5.5 0 10-4.5 10-10v-117c0-5.5-4.5-10-10-10zm-10 117h-157v-97h157v97z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M467.2 432.65H299.6v-160h16.3c14.8 0 26.8 12.1 26.7 26.9v27.9c0 29.3 23.7 53 53 53s53-23.7 53-53v-158.2c0-16.4-6.1-32.2-17.3-44.3l-78.2-89.1-15 13.2 60.6 69.1c-21.9 3.7-36.7 24.4-33 46.3 3.2 19.4 20 33.6 39.7 33.6 8.3-.1 16.4-2.6 23.2-7.4v136.8c0 18.2-14.8 33-33 33s-33-14.8-33-33v-27.7c.1-25.9-20.8-47-46.6-47.1H299.6V66.35c0-22.8-18.4-41.7-41.2-41.7H72.6c-22.8 0-41 19-41 41.7v366.3H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h457.3c5.5 0 10-4.5 10-10s-4.5-10-10.1-10zm-61.8-254.7c-11.2 0-20.2-9.1-20.2-20.2s9.1-20.2 20.2-20.2c11.2 0 20.2 9.1 20.2 20.2s-9.1 20.2-20.2 20.2zm-125.8 254.7h-228V66.35c0-11.8 9.2-21.7 21-21.7h185.8c11.8 0 21.2 10 21.2 21.7v366.3z"
  })));
}

export default SvgGasIcon;